<template>
  <div class="row">
    <div class="col-md-12">
      <table
        class="card table table-sm table-custom-primary table-bordered mb-0"
      >
        <tbody>
          <tr class="d-flex font-size-17 font-weight-bold">
            <td class="col-6">
              Prénom et nom de l'employé :
              {{
                currentEmploye.prenom
                  ? currentEmploye.prenom + ' ' + currentEmploye.nom
                  : currentEmploye.nom
              }}
            </td>
            <td class="col-6 d-flex justify-content-between">
              Matricule :
              {{ currentEmploye.matricule ? currentEmploye.matricule : '###' }}
            </td>
          </tr>

          <tr class="d-flex font-size-17 font-weight-bold">
            <td class="col-6">
              Email principal :
              {{
                currentEmploye.email_principal
                  ? currentEmploye.email_principal
                  : '###'
              }}
            </td>
            <td class="col-6">
              Téléphone :
              {{ currentEmploye.telephone ? currentEmploye.telephone : '###' }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    currentEmploye: {
      require: true,
      type: Object,
    },
  },
};
</script>
